// Setup June
// Import June SDK:
import { AnalyticsBrowser } from "@june-so/analytics-next"
import { GroupReference } from "@superwall-me/schema"
import { z } from "zod"

let apiHost: string = "superwall.com/api/telemetry"
let protocol = "https"
if (typeof window != "undefined") {
  apiHost = window.location.host + "/api/telemetry"
  protocol = window.location.protocol.replace(":", "")
}

// Near the entrypoint of your app, instantiate AnalyticsBrowser:
const baseJune = AnalyticsBrowser.load(
  {
    writeKey: process.env.NEXT_PUBLIC_JUNE_KEY!,
    cdnSettings: {
      integrations: {
        "june.so": {
          apiHost,
          protocol,
        },
      },
    },
  },
  {
    integrations: {
      "june.so": {
        apiHost,
        protocol,
      },
    },
  }
)
type TrackFunctionParams = Parameters<typeof baseJune.track>

// Get all the rest of the arguments of the track function:
type TrackWithGroupReference = (
  event: TrackFunctionParams[0],
  groupReference: z.infer<typeof GroupReference>,
  properties?: TrackFunctionParams[1],
  options?: TrackFunctionParams[2],
  callback?: TrackFunctionParams[3]
) => void

type JuneWithGroup = typeof baseJune & {
  trackWithGroupReference: TrackWithGroupReference
}
;(baseJune as JuneWithGroup).trackWithGroupReference = (
  event,
  groupReference,
  properties,
  options,
  callback
) => {
  baseJune.track(
    event,
    properties,
    {
      ...options,
      context: {
        ...((options as any)?.context || {}),
        groupReference,
      },
    },
    callback
  )
}

export const june: JuneWithGroup = baseJune as JuneWithGroup
